import { createTheme, type Shadows } from '@mui/material/styles';

const NAVY = '#2B1D16';
const NAVY_DARK = '#1E140F';
const BLUE = '#D97757';
const TEAL = '#C9832B';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: BLUE, dark: '#BF5B3D', light: '#F0A688' },
    secondary: { main: TEAL },
    background: { default: '#FAF5F0', paper: '#ffffff' },
    success: { main: '#059669' },
    warning: { main: '#B7791F' },
    error: { main: '#dc2626' },
    text: { primary: '#211A16', secondary: '#6B5F58' },
    divider: '#ECE3DC',
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: '"Inter", "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    h1: { fontSize: '2rem', fontWeight: 800, letterSpacing: '-0.02em' },
    h2: { fontSize: '1.4rem', fontWeight: 800, letterSpacing: '-0.01em' },
    h3: { fontSize: '1.15rem', fontWeight: 700 },
    h4: { fontSize: '1rem', fontWeight: 700 },
    button: { fontWeight: 600 },
  },
  shadows: [
    'none',
    ...Array(24).fill('0 1px 2px rgba(43, 29, 22, 0.06), 0 4px 12px rgba(43, 29, 22, 0.06)'),
  ] as unknown as Shadows,
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#FAF5F0',
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
        },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 600, borderRadius: 10, paddingLeft: 16, paddingRight: 16 },
        contained: {
          boxShadow: '0 1px 4px rgba(217, 119, 87, 0.25)',
          '&:hover': { boxShadow: '0 2px 8px rgba(217, 119, 87, 0.32)' },
        },
        outlined: { borderColor: '#e6dad0' },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
        outlined: { borderColor: '#ECE3DC' },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          boxShadow: '0 1px 2px rgba(43, 29, 22, 0.05), 0 6px 16px rgba(43, 29, 22, 0.06)',
          border: '1px solid #f0e6dd',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: { root: { backgroundImage: 'none' } },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 600, borderRadius: 999 },
      },
    },
    MuiTextField: {
      defaultProps: { size: 'small' },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 10 },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: 600, minHeight: 44 },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          borderRadius: '12px !important',
          border: '1px solid #f0e6dd',
          marginBottom: 10,
          '&:before': { display: 'none' },
        },
      },
    },
  },
});

export const brandColors = { navy: NAVY, navyDark: NAVY_DARK, blue: BLUE, teal: TEAL };
